/**
 * Default video constraints for use in navigator.mediaDevices.getUserMedia
 *
 * This constraints help maintain the same resolution when flipping
 * between cameras.
 */
export const DEFAULT_VIDEO_CONSTRAINTS = {
  width: {
    ideal: 1920,
  },
  height: {
    ideal: 1080,
  },
  aspectRatio: {
    ideal: 1920 / 1080,
  },
};

/**
 * The shared caller state is any state that can be read and written by both the
 * UNITE dispatcher and the caller; it's stored as a json string in the caller's
 * livekit participant metadata.
 *
 * This type needs to be kept in sync with video_to_911's ParticipantMetadata type.
 */
export type SharedCallerState = {
  facingMode: 'user' | 'environment';
  isDarkMode: boolean;
  isMuted: boolean;
  role: 'caller';
};

export const defaultSharedCallerState: SharedCallerState = {
  facingMode: 'environment',
  isDarkMode: false,
  isMuted: true,
  role: 'caller',
};

/**
 * The room metadata is any state that applies to the room as a whole, rather
 * than any participant. It's stored as a json string in the livekit room's
 * metadata.
 *
 * This type needs to be kept in sync with video_to_911's RoomMetadata
 * type.
 */
export interface RoomMetadata {
  locked: boolean;
}

export const defaultRoomMetadata: RoomMetadata = {
  locked: false,
};
